import { isMobileNative } from "util/device";

export const captureFront = () =>
    new Promise((onSuccess, onError) => {
        console.log("captureFront - new Promise start");
        if (isMobileNative) {
            console.log("captureFront - isMobileNative: yes");
            window.onBoardingFlowPlugin.captureFront().then(
                (result) => {
                    console.log("captureFront - onSuccess - result: ", result);
                    onSuccess(result);
                },
                (msg) => {
                    console.log("captureFront - onError - msg: ", msg);
                    onError(msg);
                },
            );
        } else {
            onError();
        }
        console.log("captureFront - new Promise end");
    });

export const captureBack = () =>
    new Promise((onSuccess, onError) => {
        console.log("captureBack - new Promise start");
        if (isMobileNative) {
            console.log("captureBack - isMobileNative: yes");
            window.onBoardingFlowPlugin.captureBack().then(
                (result) => {
                    console.log("captureBack - onSuccess - result: ", result);
                    onSuccess(result);
                },
                (msg) => {
                    console.log("captureBack - onError - msg: ", msg);
                    onError(msg);
                },
            );
        } else {
            onError();
        }
        console.log("captureBack - new Promise end");
    });

export const captureSelfie = (minScore) =>
    new Promise((onSuccess, onError) => {
        console.log("captureSelfie - new Promise start");
        if (isMobileNative) {
            console.log("captureSelfie - isMobileNative: yes");
            window.onBoardingFlowPlugin.captureSelfie(minScore).then(
                (result) => {
                    console.log("captureSelfie - onSuccess - result: ", result);
                    onSuccess(result);
                },
                (msg) => {
                    console.log("captureSelfie - onError - msg: ", msg);
                    onError(msg);
                },
            );
        } else {
            onError();
        }
        console.log("captureSelfie - new Promise end");
    });

export default {};
